export const LS_KEYS = {
    TRANSCRIPTIONS: 'transcriptions',
    CUSTOMER_ID: 'customer_id'
}

const APP_KEY_PREFIX = 'nut_'

const setValue = (key:string, value:any) => {
    localStorage.setItem(APP_KEY_PREFIX + key, value)
}
const getValue = (key:string) => localStorage.getItem(APP_KEY_PREFIX + key)
const removeValue = (key:string) => {
    localStorage.removeItem(APP_KEY_PREFIX + key)
}

export {
    setValue,
    getValue,
    removeValue
}
